import { MutationType } from '@tencent/slide-sdk-pb-model';
import { DataType } from '../../data';
import { BaseMutation } from '../base';
import { Rule } from '../base/mutation-rules';
import type { PresentationDataModel } from '../../model/presentation-data-model';
import type { MaybeError } from '../base/base-mutation';
import type { IValidAddCommentMutationData, IValidRemoveCommentMutationData } from '../base/valid-mutation-data';

export class AddCommentMutation extends BaseMutation<PresentationDataModel, IValidAddCommentMutationData> {
    public readonly type: MutationType = MutationType.AddComment;

    public apply(presentation: PresentationDataModel) {
        if (!this.data.pageId) return;
        const { pageId, commentType, groupId, shapeId, anchorPosition, textAnchor, createdTimeStamp } = this.data;
        const page = presentation.store.models.get(pageId, DataType.Slide);
        page?.store.patchData({
            commentGroupMap: {
                [groupId]: { commentType, shapeId, anchorPosition, textAnchor, createdTimeStamp },
            },
        });
    }

    public invert(): [IValidRemoveCommentMutationData] {
        const { pageId, commentType, groupId, shapeId } = this.data;
        return [
            {
                type: MutationType.RemoveComment,
                pageId,
                commentType,
                groupId,
                shapeId,
            },
        ];
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { pageId, commentType, groupId, shapeId, anchorPosition, textAnchor } = this.data;
        return Rule.every(
            () => Rule.page.should.exist(presentation, pageId),
            () => Rule.comment.commentType.should.exist(commentType),
            () => Rule.comment.groupId.should.notExist(presentation, pageId, groupId),
            () => Rule.comment.shapeId.is.valid(commentType, shapeId),
            () => Rule.comment.anchorPosition.should.exist(commentType, anchorPosition),
            () => Rule.comment.anchorPosition.is.valid(anchorPosition),
            () => Rule.comment.textAnchor.should.exist(commentType, textAnchor),
            () => Rule.comment.textAnchor.is.valid(textAnchor),
        );
    }
}
